import { compactList, fullUserName, userBusinessProfile } from './businessProfile';

const first = (items = []) => Array.isArray(items) && items.length ? items[0] : '';
const listText = (items = [], limit = 3) => compactList((items || []).filter(Boolean), limit);

export function buildBusinessIntroductionDraft({ senderUser = {}, targetUser = {}, senderCompany = {}, targetCompany = {}, match = null } = {}) {
  const sender = userBusinessProfile(senderUser, senderCompany);
  const target = userBusinessProfile(targetUser, targetCompany);
  const senderName = fullUserName(senderUser) || 'a TELCOFAIR member';
  const targetName = fullUserName(targetUser) || 'there';
  const senderCompanyName = sender.companyName || senderCompany.companyName || senderCompany.name || 'our company';
  const senderRole = sender.jobTitle || senderUser.jobTitle || senderUser.designation || '';
  const senderSpecialization = listText(sender.specialization, 2);
  const primary = listText(sender.primaryServices, 2);
  const secondary = listText(sender.secondaryServices, 2);
  const regions = listText([...sender.primaryRegions, ...sender.secondaryRegions], 3);
  const needs = listText([...sender.primaryNeeds, ...sender.secondaryNeeds], 3);
  const targetNeeds = listText([...target.primaryNeeds, ...target.secondaryNeeds], 3);
  const targetOffers = listText([...target.primaryServices, ...target.secondaryServices], 3);
  const reason = match?.reasons?.[0] || '';

  const opening = `Hello ${targetName}, I’m ${senderName}${senderRole ? `, ${senderRole}` : ''} at ${senderCompanyName}.`;
  const capabilityBits = [
    senderSpecialization ? `We specialise in ${senderSpecialization}` : '',
    primary ? `with primary services including ${primary}` : '',
    secondary ? `and secondary capabilities such as ${secondary}` : '',
    regions ? `across ${regions}` : '',
  ].filter(Boolean).join(' ');
  const fitBits = [
    reason ? `TELCOFAIR identified a relevant business fit: ${reason}.` : '',
    targetNeeds && primary ? `Your stated requirements around ${targetNeeds} appear relevant to what we provide.` : '',
    needs && targetOffers ? `We are also exploring ${needs}, which may align with your capabilities in ${targetOffers}.` : '',
  ].filter(Boolean).join(' ');

  return [opening, capabilityBits ? `${capabilityBits}.` : '', fitBits, 'If this looks relevant, I would be glad to connect here on TELCOFAIR. You can decide whether to open a chat or share suitable calendar availability.']
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export default buildBusinessIntroductionDraft;
